import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 8v-2a2 2 0 0 1 2 -2h2","key":"svg-0"}],["path",{"d":"M4 16v2a2 2 0 0 0 2 2h2","key":"svg-1"}],["path",{"d":"M16 4h2a2 2 0 0 1 2 2v2","key":"svg-2"}],["path",{"d":"M16 20h2a2 2 0 0 0 2 -2v-2","key":"svg-3"}],["path",{"d":"M12 11l0 .01","key":"svg-4"}],["path",{"d":"M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5","key":"svg-5"}]]

const IconLiveView = createReactComponent('outline', 'live-view', 'LiveView', __iconNode);

export default IconLiveView;